import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

const PlotsTableHeader: FC = () => {
  const { t } = useTranslate();

  return (
    <>
      <thead className="table-light">
        <tr>
          <th className="text-left">{t('Number')}</th>
          <th className="text-left">{t('Area')}</th>
          <th className="text-left">{t('Type')}</th>
          <th className="text-left">{t('SubType')}</th>
          <th className="text-left">{t('Buildings')}</th>
          <th className="text-center" />
        </tr>
      </thead>
    </>
  );
};

export default PlotsTableHeader;
